import styled from 'styled-components';

const StyledSvg = styled.svg`
	position: absolute;
	top: 0;
	left: 0;
	display: block;
	z-index: 10;
`;

const StyledLine = styled.line<{ $stroke: string }>`
	stroke: ${(props) => props.$stroke};
	box-shadow: 0 0 12px ${(props) => props.$stroke}7f;
`;

export { StyledLine, StyledSvg };
